import ActionComponent from 'app/shared/components/common/action-component';
import AvatarWithBadge from 'app/shared/components/mobile/avatar-with-badge/avatar-with-badge';
import { Markup } from 'interweave';
import React from 'react';
import './style.scss';

const DesktopNoMatchedAdhesion = props => {
  const { nextView, dataConf, accoutAssignementCms, avatar } = props;
  return (
    <div className="no-matched-contract-content">
      <AvatarWithBadge
        hideButton
        avatar={avatar}
        title=
        {[accoutAssignementCms?.no_mattched_subscription?.not_matched_sub_avatar_text]}
      />
      <br />
      <br />
      <div className="contact-form">
        <div className="item-form">
          <div className="d-flex flex-row">
            <div className="mobile-tel-icon">
              <img src={accoutAssignementCms?.administrator_contact?.phone_icon} style={{ height: '23px', width: '23px' }} />
            </div>
            <div className="info-contact-style">
              <b className="label-contact-style">  <Markup content={accoutAssignementCms?.no_mattched_subscription?.phone_text} /></b>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
};

export default DesktopNoMatchedAdhesion;
